import { Injectable } from '@angular/core';
import { HrResourceName } from '../model/hr-resource-name';
import { UiTranslateLoaderService } from 'ui-shared';
import { Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class HrResourceLoader {
    allResourceList: Array<HrResourceName> = [];

    constructor(private uiTranslateLoaderService: UiTranslateLoaderService) {
        this.allResourceList.push(HrResourceName.hrCommon);
        this.allResourceList.push(HrResourceName.hrConstraintException);
    }

    init(resourceList: Array<HrResourceName>): Observable<any> {
        const prevSize = this.allResourceList.length;
        for (let res of resourceList) {
            if (!this.allResourceList.includes(res)) {
                this.allResourceList.push(res);
            }
        }
        if (prevSize !== this.allResourceList.length) {
            return this.uiTranslateLoaderService.init(this.allResourceList.join(','));
        } else {
            return of([]);
        }
    }
}
